import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReportType } from '@app/domain/model/report-type';

import { PurchaseReport } from '../purchase-report';

@Injectable({
  providedIn: 'root'
})
export class PurchaseReportCreationEditingService {

  constructor(private http: HttpClient) {
  }

  addPurchaseReport(report: PurchaseReport, dealerId?: number): Observable<any> {

    // Convert the purchase report into JSON representation, ...
    const requestBody = JSON.stringify(
      Object.assign({}, {
        amendments: report.amendments,
        boatNotUsed: report.boatNotUsed,
        notifyFisher: report.notifyFisher,
        purchases: report.purchases.map(purchase => Object.assign({}, purchase)),
        reportDate: report.reportDate,
        reportType: ReportType[report.reportType],
        remarks: report.remarks,
        sellerId: report.sellerId,
        vessel: report.vessel
      }));

    // ... and send it to the back-end.
    return this.http
      .post('dealers/' + (dealerId ? dealerId : 'mine') + '/reports/', requestBody, { headers: { 'Content-Type': 'application/json' } })
      .pipe(catchError(this.handleError));
  }

  editPurchaseReport(reportId: number, report: PurchaseReport) {

    // Convert the purchase report into JSON representation, ...
    const requestBody = JSON.stringify(
      Object.assign({}, {
        amendments: report.amendments,
        boatNotUsed: report.boatNotUsed,
        notifyFisher: report.notifyFisher,
        purchases: report.purchases.map(purchase => Object.assign({}, purchase)),
        reportDate: report.reportDate,
        reportType: ReportType[report.reportType],
        remarks: report.remarks,
        sellerId: report.sellerId,
        vessel: report.vessel
      }));

    // ... and send it to the back-end.
    return this.http
      .put(`reports/${reportId}/`, requestBody, { headers: { 'Content-Type': 'application/json' } })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: Error) {
    if (isDevMode()) {
      console.error('Add purchase report problem: ', error);
    }

    return throwError(error);
  }

}
